var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.452,
    height: 20.217,
    viewBox: "0 0 20.452 20.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(0 -1.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_1_",
    transform: "translate(0.001 1.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1.939,22.637a1.937,1.937,0,0,1-1.375-.465,1.937,1.937,0,0,1,0-2.732L17.011,2.994a1.937,1.937,0,0,1,2.828,2.635L3.3,22.172a1.937,1.937,0,0,1-1.356.465Z",
    transform: "translate(-0.001 -2.431)",
    fill: "#a4a7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M19.8,22.05a1.937,1.937,0,0,1-1.356-.562L1.994,5.041A1.937,1.937,0,0,1,4.726,2.31L21.27,18.757a1.937,1.937,0,0,1,.09,2.738q-.044.047-.09.09a1.937,1.937,0,0,1-1.472.465Z",
    transform: "translate(-1.431 -1.844)",
    fill: "#a4a7af"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4835fd44241bee25c3ed0cab97d26b40.svg";
export { ForwardRef as ReactComponent };